<template>
  <div>
    <ValidationObserver ref="formModalValidate">
      <b-row v-if="formData">
        <b-col cols="12" md="6">
          <b-form-group :label="$t('student')">
            <b-input-group>
              <div class="label-as-input">{{ isNotNullValue(formData.student_name) }}
                {{ isNotNullValue(formData.student_surname) }}
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group :label="$t('module')">
            <b-input-group>
              <div class="label-as-input">{{ isNotNullValue(formData.module_date_name) }}</div>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group :label="$t('initial_course')">
            <b-input-group>
              <div class="label-as-input">{{ isNotNullValue(formData.initial_course_name) }}</div>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group :label="$t('type')">
            <b-input-group>
              <div class="label-as-input">{{ isNotNullValue(formData.type) }}</div>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group :label="$t('reason')">
            <b-input-group>
              <div class="label-as-input">{{ isNotNullValue(formData.reason) }}</div>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group :label="$t('explanation')">
            <b-input-group>
              <div class="label-as-input">{{ isNotNullValue(formData.explanation) }}</div>
            </b-input-group>
          </b-form-group>
        </b-col>

      </b-row>
      <b-row>
        <b-col cols="12">
          <ValidationProvider name="status" rules="required" v-slot="{valid, errors}">
            <b-form-group :label="$t('status')">
              <b-form-select v-model="formData.status"
                             :options="statusOptions"
                             :state="errors[0] ? false : null"
              />
              <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>
        </b-col>
        <b-col cols="12">
          <b-form-group :label="$t('directors_note')">
            <ValidationProvider name="directors_note" v-slot="{ errors }">
              <b-input-group class="mb-1">
                <b-textarea v-model="formData.directors_note" :state="errors[0] ? false : null"/>
              </b-input-group>
              <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
            </ValidationProvider>
          </b-form-group>
        </b-col>
        <b-col cols="12" v-if="formData.module_date_id">
          <ValidationProvider name="session_id" rules="" v-slot="{ valid, errors }">
            <b-form-group :label="$t('new_course')">
              <SessionsSelectbox v-model="formData.session_id" :module-date-id="formData.module_date_id"
                                 :has-quota="true"
                                 :is-module-date-required="true" :validate-error="errors[0]"/>
            </b-form-group>
          </ValidationProvider>
        </b-col>
      </b-row>

      <div class="d-flex justify-content-center mt-2">
        <b-button
            variant="primary"
            @click="updateForm"
            :disabled="formLoading"
        >
          {{ $t("save") }}
        </b-button>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
// Components
import SessionsSelectbox from "@/components/interactive-fields/SessionsSelectbox.vue";

// Services
import EslChangeOfClassRequestService from "@/services/EslChangeOfClassRequestService";

// Other
import {ValidationProvider, ValidationObserver} from "vee-validate";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    SessionsSelectbox,
  },
  props: {
    formId: {
      type: Number,
    },
    student: {type: Object, default: null},
    availableModules: {type: Array, default: () => []}
  },
  computed: {
    moduleOptions() {
      return [
        {value: null, text: this.$t('select'), disabled: true},
        ...((this.availableModules || [])
            .filter(m => m && m.id != null)
            .map(m => ({
              value: Number(m.id),
              text: m.name
            })))
      ];
    },
  },
  data() {
    return {
      formData: {
        status: null,
        directors_note: null,
        session_id: null,
        module_date_id: null,
        instructor_name: null,
        instructor_surname: null,
        student_name: null,
        student_surname: null,
        course_name: null,
      },
      formLoading: false,
      instructorValueObject: {},
      statusOptions: [
        {value: 'waiting', text: 'Waiting'},
        {value: 'approved', text: this.$t('approved')},
        {value: 'declined', text: this.$t('declined')}
      ],
    };
  },
  watch: {
    formId: function (val) {
      this.get(val);
    },
  },
  async created() {
    await this.get(this.formId);
  },
  methods: {
    get(id) {
      EslChangeOfClassRequestService.get(id)
          .then((response) => {
            let data = response.data.data;
            this.formData = data;
          })
          .catch((e) => {
            this.showErrors(e);
          });
    },

    async updateForm() {
      const isValid = await this.$refs.formModalValidate.validate();
      if (isValid && this.formId) {
        this.formLoading = true;

        let payload = {...this.formData};
        delete payload.student_name;
        delete payload.student_surname;
        delete payload.instructor_name;
        delete payload.instructor_surname;
        delete payload.course_name;

        EslChangeOfClassRequestService.update(this.formId, payload)
            .then((response) => {
              this.$emit("updateFormSuccess", true);
              this.$toast.success(
                  this.$t("api." + response.data.message)
              );
            })
            .catch((e) => {
              this.showErrors(e, this.$refs.formModalValidate);
            })
            .finally(() => {
              this.formLoading = false;
            });
      }
    },
  },
};
</script>
